import * as React from "react";
import { format } from "date-fns";
import { enGB } from "date-fns/locale";

import { DateTime } from "affinityUI/data/valueDisplay";
import { TestResult } from "types/patient";

import { ResultWrap } from "./resultWrap";

export const ResultRow: React.FC<{
  result: TestResult;
  confirmatoryThreshold?: Maybe<number>;
}> = ({ result }) => (
  <tr key={result.id} data-testid={result.id}>
    <td
      className="no-wrap"
      scope="row"
      data-testid={format(new Date(result.dateRecorded), "dd-MM-yyyy HH:mm", { locale: enGB })}
    >
      <DateTime format={DateTime.FORMAT.DATE} value={result.dateRecorded} />
    </td>
    <td className="no-wrap">
      <DateTime format={DateTime.FORMAT.TIME} value={result.dateRecorded} />
    </td>
    <td>
      <ResultWrap warning={Boolean(result.whiteBloodCells.measurementInterval?.outOfRange)} aria-label="WBC">
        {result.whiteBloodCells.value}
      </ResultWrap>
    </td>
    <td>
      <ResultWrap warning={Boolean(result.granulocytes.measurementInterval?.outOfRange)} aria-label="Granulocyte count">
        {result.granulocytes.value}
      </ResultWrap>
    </td>
  </tr>
);
